__turbopack_context__.v({
  "active": "Pill-module__-RgZ9a__active",
  "activeLabel": "Pill-module__-RgZ9a__activeLabel",
  "category": "Pill-module__-RgZ9a__category",
  "categoryLabel": "Pill-module__-RgZ9a__categoryLabel",
  "circle": "Pill-module__-RgZ9a__circle",
  "circleMedium": "Pill-module__-RgZ9a__circleMedium",
  "circleNumber": "Pill-module__-RgZ9a__circleNumber",
  "circleSmall": "Pill-module__-RgZ9a__circleSmall",
  "circleXSmall": "Pill-module__-RgZ9a__circleXSmall",
  "inactive": "Pill-module__-RgZ9a__inactive",
  "inactiveLabel": "Pill-module__-RgZ9a__inactiveLabel",
  "label": "Pill-module__-RgZ9a__label",
  "rectangle": "Pill-module__-RgZ9a__rectangle",
  "rectangleLabel": "Pill-module__-RgZ9a__rectangleLabel",
  "status": "Pill-module__-RgZ9a__status",
  "statusLabel": "Pill-module__-RgZ9a__statusLabel",
});
